import type { SplitTheme } from './light'
import { commonDark } from '../../_styles/common'

const splitDark: SplitTheme = {
  name: 'Split',
  common: commonDark
}

export default splitDark
